import React from 'react'

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { STATUS } from "state/requestStatus/reducer";
import {Spacer} from 'layout/util'
import { withRouter } from 'react-router-dom';
import Color from 'constants/colors'

import {Wrapper, Notes, MyNotesContainer, 
  ContainerLabel, OptionLabel, 
  Options, SpreadApart, MoreInfo
} from './styles'

import styled from 'styled-components'

const Underline = styled.span`
  border-bottom: 2px solid black;
  color: ${Color('purple')};

`;

class Reader extends React.Component {

	render() {
		const { onToggleEdit, showEditor, votePref, placeholderText } = this.props.data;
    const { status, data } = votePref;
    let {voteText, reason} = data;
    voteText = !voteText ? placeholderText.first : voteText;
    reason = !reason ? placeholderText.second : reason;
    const isLoading = (status === STATUS.LOADING);

    const LoadingComponent = <Notes style={{minHeight: 175}}>Loading notes...</Notes>

    const noteComponent = 
      <span>
        I feel <Underline>{voteText}</Underline> about this proposition and I <Underline>{reason}</Underline>.
      </span>
    const noteTitle = votePref.user ? `A note from ${votePref.user.name}` : "A note from the author";

    // -- logic for the options under the note container
    let options = <Spacer height={20}/>; //-- empty space
    if (this.props.auth.loggedIn && !showEditor) {
      options = <OptionLabel onClick={onToggleEdit}>Edit</OptionLabel>
    } else if ( showEditor) {
      options =
        <React.Fragment>
          <OptionLabel onClick={onToggleEdit}>Cancel</OptionLabel>
          <OptionLabel onClick={this.handleSave}>Save</OptionLabel>
        </React.Fragment>
    }

		return(
      <Wrapper>
        { !isLoading &&
          <React.Fragment>
            <ContainerLabel>
            	<span role="img" aria-label="notebook">📓</span> 
            		{noteTitle}
        		</ContainerLabel>
            <MyNotesContainer>
              <Notes style={{userSelect: 'none'}}>
                { noteComponent }
              </Notes>
            </MyNotesContainer>
            <SpreadApart>
              <MoreInfo to="/election/personalized-guide">
                Learn more bout this
              </MoreInfo>
              <Options>
                {options}
              </Options>
            </SpreadApart>
          </React.Fragment>
        }
        { isLoading && LoadingComponent }
      </Wrapper>
		)
	}	
}

Reader.contextTypes = {
  store: PropTypes.object
};

function mapStateToProps(state) {
  const user = state.user.data || {};
  const { votePrefs, auth} = state;
  return { user, votePrefs, auth };
}

export default connect(mapStateToProps, {})(withRouter(Reader));



// WEBPACK FOOTER //
// ./src/components/interactive/votePref/VotePrefReader.js